// extracted by mini-css-extract-plugin
export default {"hover":"CardHover_hover__7oV07","left":"CardHover_left__IOyMM","dark":"CardHover_dark__jxrnt"};